/// <reference path="./Window.d.ts" />
import Utils from "./Utils";
export {};
String.prototype.toEscaped = function(): string {
    return Utils.escapeHtmlChars(this as string);
};
